import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import Img from "gatsby-image"

const Container = styled.div`
  background-color: #d43826;
  max-height: 114px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow: hidden;

  @media (max-width: 876px) {
    max-height: inherit;
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  max-width: 900px;

  @media (max-width: 876px) {
    flex-direction: column;
  }
`

const HeaderText = styled.h1`
  text-transform: uppercase;
  color: white;
  font-size: 25px;
  font-family: "Libre Franklin";
  font-weight: bold;
  margin: 0;
  text-align: right;

  @media (max-width: 876px) {
    font-size: 20px;
  }
`

const ItineraryText = styled.h3`
  color: white;
  margin: 0;
  font-family: "Oswald";
  font-weight: 400;
  font-size: 14px;
  text-transform: uppercase;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: center;
  margin-right: 10px;

  @media (max-width: 876px) {
    margin: 10px 0;
  }
`

const StyledImage = styled(Img)`
  margin-top: 7px;
  bottom: -1px;
`

// :( https://spectrum.chat/gatsby-js/general/using-variables-in-a-staticquery~abee4d1d-6bc4-4202-afb2-38326d91bd05
const uluruImageQuery = graphql`
  query {
    bigImage: file(relativePath: { eq: "northern-territory/uluru.png" }) {
      sharp: childImageSharp {
        fixed(width: 580) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    smallImage: file(relativePath: { eq: "northern-territory/uluru.png" }) {
      sharp: childImageSharp {
        fixed(width: 380) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`
// TODO: Seems this is not working
const NorthernTerritoryHeader = () => {
  const data = useStaticQuery(uluruImageQuery)
  const sources = [
    {
      ...data.bigImage.sharp.fixed,
      media: `(min-width: 877px)`,
    },
    {
      ...data.smallImage.sharp.fixed,
      media: `(max-width: 876px)`,
    },
  ]

  return (
    <Container>
      <Wrapper>
        <TextWrapper>
          <HeaderText>Northern Territory</HeaderText>
          <ItineraryText>Uluru - Darwin</ItineraryText>
        </TextWrapper>
        <StyledImage fixed={sources} loading="eager" fadeIn={false} />
      </Wrapper>
    </Container>
  )
}

export default NorthernTerritoryHeader
